export default __webpack_public_path__ + "static/media/poignees.c173d1cf.png";